import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-select/dist/vue-select.css';
import 'vue2-datepicker/index.css';
import '@/assets/style/main.scss';
import 'regenerator-runtime/runtime';
import 'vue2-datepicker/locale/ru';
import 'vue2-autocomplete-js/dist/style/vue2-autocomplete.css';
import 'vue-moment';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import Vue from 'vue';

import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import VTooltip from 'v-tooltip';
import VueLodash from 'vue-lodash';
import VueMeta from 'vue-meta';
import Notifications from 'vue-notification';
import VueScrollactive from 'vue-scrollactive';
import VueScrollTo from 'vue-scrollto';
import vSelect from 'vue-select';
import VueTheMask from 'vue-the-mask';
import Autocomplete from 'vue2-autocomplete-js';
import DatePicker from 'vue2-datepicker';
import Vuelidate from 'vuelidate';
import VueVirtualScroller from 'vue-virtual-scroller'

import { PAGES } from '@/constants/pages';
import ApiPlugin from '@/plugins/api-plugin';
import StringHelper from '@/plugins/string-helper.plugin';
import TooltipConfig from '@/plugins/tooltip-config.plugin';

import App from './App.vue';
import toastPlugin from './plugins/notification.plugin';
import router from './router';
import api from './services/api';
import interceptorsBuild from './services/intercepters';
import store from './store';
import { notEmptyObject } from './utils/notEmptyObject';
import _globalVariables from './mixins/_global-variables';

import clickOutside from './directives/click-outside';
import swipe from './directives/swipe'

Vue.use(VueVirtualScroller)

Vue.use(VueTheMask);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

Vue.use(TooltipConfig);
Vue.use(StringHelper);
Vue.use(Notifications);
Vue.use(toastPlugin);
Vue.use(VueScrollactive);
Vue.use(VTooltip);
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
Vue.use(ApiPlugin);

Vue.use(VueScrollTo, {
  container: '.guide__main',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.use(VueLodash, { name: 'custom', lodash: { debounce, isEmpty } });

Vue.config.productionTip = false;

Vue.component('autocomplete', Autocomplete);
Vue.component('date-picker', DatePicker);
Vue.component('v-select', vSelect);

Vue.directive('click-outside', clickOutside);
Vue.directive('swipe', swipe)

interceptorsBuild();

Vue.mixin(_globalVariables);

Vue.mixin({
  data: () => ({
    windowWidth: 0,
    isMobile: false,
    isMobile768: false,
    isMobileOuter: false,
    baseUrl: window.location.origin,
    mosokna: false,
  }),

  methods: {
    updateDangerPopup({ isOpen = false, text = '' }) {
      this.$store.commit('common/updateDangerPopup', { isOpen, text });
    },

    // проверка ошибки в блоке try
    $apiSuccessError(response, msg) {
      if (response?.data && !response.data.success) {
        this.$danger(this.$api.getErrorMessage({ response }, msg))
      }
    },

    $apiError(err, msg) {
      return this.$danger(this.$api.getErrorMessage(err, msg))
    },

    updatePopup(state, name, value = null) {
      this.$store.commit('common/updateCurrentPopup', { state: state, name: name, value });
    },

    togglePreload(val) {
      this.$store.commit('common/updatePreload', val);
    },

    updatePopoverV2(state, name, value = null) {
      this.$store.commit('common/updateCurrentPopover', { state, name, value });
    },
    updatePopover(state, name, value = null) {
      if (
        store.state.common.currentPopover.name === name &&
        store.state.common.currentPopover.state === true
      ) {
        this.$store.commit('common/updateCurrentPopover', { state: null, name: null });
      } else {
        this.$store.commit('common/updateCurrentPopover', { state: state, name: name, value });
      }
    },

    createFormData(obj) {
      if (typeof obj === 'object') {
        let data = new FormData();

        for (let key in obj) {
          data.append(key, obj[key]);
        }

        return data;
      }
    },

    updateWidth() {
      this.windowWidth = window.innerWidth;
      this.isMobile = this.windowWidth < 1000;
      this.isMobileOuter = window.outerWidth < 1000;
      this.isMobile768 = this.windowWidth < 769;
    },

    changeSum(string) {
      if (string === 0) {
        return 0;
      }
      const str = String(string);
      const dotAfter = str.split('.')[1];
      let dotBefore = str.split('.')[0];
      if (dotBefore.length <= 3) {
        return str;
      }
      dotBefore = dotBefore.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      if (dotAfter) {
        return `${dotBefore}.${dotAfter}`;
      }
      return dotBefore;
    },

    notEmptyObject(object) {
      return notEmptyObject(object);
    },

    checkNumberOnly(e, isNumberZero = false) {
      const value = e.target.value;
      if (!isNumberZero && ['0'].includes(e.key) && value === '') {
        e.preventDefault();
      }
      if (isNumberZero && ['0'].includes(e.key) && value === '00') {
        e.preventDefault();
      }
      if (['+', '-', 'e', '.', ','].includes(e.key)) {
        e.preventDefault();
      }
      if (
        e.keyCode &&
        (((e.keyCode < 8 || e.keyCode > 9) && e.keyCode < 46) ||
          (e.keyCode > 57 && (e.keyCode < 96 || e.keyCode > 105)))
      ) {
        e.preventDefault();
      }
    },

    roundNum(num, fixed = 4) {
      return Number.parseFloat(Number(num).toFixed(fixed));
    },
  },

  watch: {
    $route(to, from) {
      if (to.name !== PAGES.wholesale.name && from.name === PAGES.wholesale.name) {
        window.location.reload();
      }
    },
  },

  mounted() {
    this.updateWidth();
  },

  created() {
    window.addEventListener('resize', this.updateWidth);
    const url = window.location.host.split('.');

    if (
      this.getDealer?.uuid === '0c51b5db92426e7edf061d4f17bde13c' ||
      url[0] === '0c51b5db92426e7edf061d4f17bde13c' ||
      url.includes('mosokna')
    ) {
      this.mosokna = true;
    }
  },
});

Vue.prototype.$http = api;
api.defaults.timeout = 10000;

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.common['Authorization'] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
api.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          //do something
          break;
        case 401:
          alert('session expired');
          break;
        case 403:
          //do smth
          break;
        case 404:
          alert('page not exist');
          break;
        case 502:
          setTimeout(() => {
            // do smth like relogin
          }, 1000);
      }
      return Promise.reject(error.response);
    }
  },
);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
